import {
  AppWindow,
  Bell,
  Building2,
  ChartCandlestick,
  Crosshair,
  Globe,
  HomeIcon,
  Plus,
  RadioReceiver,
  RouterIcon,
  FileCode,
  ScrollText,
  Settings,
  Sheet,
  SquareFunction,
  User2,
  Workflow,
  Map,
  LayoutDashboard,
  ListTree,
} from "lucide-react";
import type { ScRoute } from "~/types/ui";

export const navRoutes: ScRoute[] = [
  {
    label: "home.nav",
    to: "/",
    icon: <HomeIcon className="w-5 h-5" />,
    permission: "Dashboard.View",
  },
  {
    label: "dashboard.nav",
    to: "/dashboard",
    icon: <LayoutDashboard className="w-5 h-5" />,
    permission: "Dashboard.View",
    children: [
      {
        label: "dashboard.nav",
        to: "/dashboard",
        icon: <ListTree className="w-5 h-5" />,
        permission: "Dashboard.View",
      },
      {
        label: "dashboard.navCreate",
        to: "/dashboard/create",
        icon: <Plus className="w-5 h-5" />,
        permission: "Dashboard.Create",
      },
    ],
  },

  {
    label: "applications.nav",
    to: "/applications",
    icon: <AppWindow className="w-5 h-5" />,
    permission: "Application.View",
    children: [
      {
        label: "applications.nav",
        to: "/applications",
        icon: <AppWindow className="w-5 h-5" />,
        permission: "Application.View",
      },
      {
        label: "applications.navCreate",
        to: "/applications/create",
        icon: <Plus className="w-5 h-5" />,
        permission: "Application.Create",
      },
    ],
  },

  {
    label: "nodes.nav",
    to: "/nodes",
    icon: <RadioReceiver className="w-5 h-5" />,
    permission: "Tag.View",
    children: [
      {
        label: "nodes.nav",
        to: "/nodes",
        icon: <Sheet className="w-5 h-5" />,
        permission: "Tag.View",
      },
      {
        label: "nodes.scope.nav",
        to: "/nodes/scope",
        icon: <Crosshair className="w-5 h-5" />,
        permission: "Tag.View",
      },
      {
        label: "map.nav",
        to: "/nodes/map",
        icon: <Map className="w-5 h-5" />,
        permission: "Tag.View",
      },
      {
        label: "nodes.navCreate",
        to: "/nodes/create",
        icon: <Plus className="w-5 h-5" />,
        permission: "Tag.Create",
      },
    ],
  },

  {
    label: "gateways.nav",
    to: "/gateways",
    icon: <RouterIcon className="w-5 h-5" />,
    permission: "Gateways.View",
    children: [
      {
        label: "gateways.nav",
        to: "/gateways",
        icon: <Sheet className="w-5 h-5" />,
        permission: "Gateways.View",
      },
      {
        label: "gateways.navCreate",
        to: "/gateways/create",
        icon: <Plus className="w-5 h-5" />,
        permission: "Gateways.Create",
      },
    ],
  },

  {
    label: "manage.nav",
    to: "/manage",
    icon: <ChartCandlestick className="w-5 h-5" />,
    children: [
      {
        label: "company.nav",
        to: "/company",
        icon: <Building2 className="w-5 h-5" />,
        permission: "Company.View",
        children: [
          {
            label: "company.navUsers",
            to: "/company/users",
            icon: <User2 className="w-5 h-5" />,
            permission: "Company.View",
          },
          {
            label: "user.navCreate",
            to: "/company/user/create",
            icon: <Plus className="w-5 h-5" />,
            permission: "User.Create",
          },
          {
            label: "company.navSettings",
            to: "/company/settings",
            icon: <Settings className="w-5 h-5" />,
            permission: "Company.Update",
          },
        ],
      },

      {
        label: "formulas.nav",
        to: "/formulas",
        icon: <SquareFunction className="w-5 h-5" />,
        permission: "Formula.View",
      },

      {
        label: "alarms.nav",
        to: "/alarms",
        icon: <Bell className="w-5 h-5" />,
        permission: "Alarm.View",
        children: [
          {
            label: "alarms.nav",
            to: "/alarms",
            icon: <Sheet className="w-5 h-5" />,
            permission: "Alarm.View",
          },
          {
            label: "alarms.navCreate",
            to: "/alarms/create",
            icon: <Plus className="w-5 h-5" />,
            permission: "Alarm.Create",
          },
        ],
      },

      {
        label: "reports.nav",
        to: "/reports",
        icon: <Sheet className="w-5 h-5" />,
        permission: "Report.View",
        children: [
          {
            label: "reports.nav",
            to: "/reports",
            icon: <Sheet className="w-5 h-5" />,
            permission: "Report.View",
          },
          {
            label: "reports.navCreate",
            to: "/reports/create",
            icon: <Plus className="w-5 h-5" />,
            permission: "Report.Create",
          },
        ],
      },

      {
        label: "actions.nav",
        to: "/actions",
        icon: <Workflow className="w-5 h-5" />,
        permission: "Actions.View",
        children: [
          {
            label: "actions.nav",
            to: "/actions",
            icon: <Sheet className="w-5 h-5" />,
            permission: "Actions.View",
          },
          {
            label: "actions.navCreate",
            to: "/actions/create",
            icon: <Plus className="w-5 h-5" />,
            permission: "Actions.Create",
          },
        ],
      },

      {
        label: "scripts.nav",
        to: "/scripts",
        icon: <FileCode className="w-5 h-5" />,
        permission: "Script.View",
        children: [
          {
            label: "scripts.nav",
            to: "/scripts",
            icon: <Sheet className="w-5 h-5" />,
            permission: "Script.View",
          },
          {
            label: "scripts.navCreate",
            to: "/scripts/create",
            icon: <Plus className="w-5 h-5" />,
            permission: "Script.Create",
          },
        ],
      },
    ],
  },

  {
    label: "settings.nav",
    to: "/settings",
    icon: <Settings className="w-5 h-5" />,
    permission: "CompanySettings.View",
    children: [
      {
        label: "settings.navCompany",
        to: "/settings/company",
        icon: <Building2 className="w-5 h-5" />,
        permission: "CompanySettings.Update",
      },
      {
        label: "settings.navGlobal",
        to: "/settings/global",
        icon: <Globe className="w-5 h-5" />,
        permission: "GlobalSettings.Update",
      },
      {
        label: "changelog.nav",
        to: "/changelog",
        icon: <ScrollText className="w-5 h-5" />,
        permission: "CompanySettings.Update",
      },
    ],
  },
];
